import { render, staticRenderFns } from "./MyPasswordForm.vue?vue&type=template&id=818a1024"
import script from "./MyPasswordForm.vue?vue&type=script&lang=js"
export * from "./MyPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports